import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../../shared/core2Config";
import { BaseApiPublicLoginTemplateService } from "../../shared/base-api-public-login-template.service";

@Injectable({ providedIn: "root" })
export class CompanyEntitySalesAvailableCreditLimitService extends BaseApiPublicLoginTemplateService<any, any, any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/company-entity-sales-credit-limits/available-credit-limit/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/company-entity-sales-credit-limits/available-credit-limit/backoffice-ep";
    this.endpoint_path_login_entity_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/company-entity-sales-credit-limits/available-credit-limit/login-entity-ep";
    this.httpClient = http;
  }
}
